module.exports = __webpack_public_path__ + "img/c02_buildingstartechstrongholdtower_Normal_ua.6a79feda.webp";